import { useEffect } from 'react';

export default function useMouseInactivity(ref) {
  useEffect(() => {
    const el = ref?.current;

    if (!el) {
      return;
    }

    let inactivityTimer = null;
    let isInactive = false;

    const setInactive = value => {
      if (isInactive === value) {
        return;
      }

      isInactive = value;
      el.toggleAttribute('data-inactive', value);
    };

    const clearInactivityTimer = () => {
      if (inactivityTimer !== null) {
        clearTimeout(inactivityTimer);
        inactivityTimer = null;
      }
    };

    const onMouseActivity = () => {
      setInactive(false);
      clearInactivityTimer();
      inactivityTimer = setTimeout(() => setInactive(true), 5000);
    };

    const onMouseLeave = () => {
      clearInactivityTimer();
      setInactive(false);
    };

    el.addEventListener('mouseenter', onMouseActivity);
    el.addEventListener('mousemove', onMouseActivity);
    el.addEventListener('mouseleave', onMouseLeave);

    // The mouse is already over the container at the moment of mounting
    if (el.matches(':hover')) {
      onMouseActivity();
    }

    return () => {
      el.removeEventListener('mouseenter', onMouseActivity);
      el.removeEventListener('mousemove', onMouseActivity);
      el.removeEventListener('mouseleave', onMouseLeave);
      clearInactivityTimer();
      el.removeAttribute('data-inactive');
    };
  }, [ref]);
}
